/**
 * Protected Route - Login guard
 */

import { ReactNode, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import { isAuthenticated, getToken } from '../utils/auth'
import request from '../utils/request'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isValid, setIsValid] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated()) {
        setIsLoading(false)
        setIsValid(false)
        return
      }

      try {
        const res = await request.get('/auth/admin/info') as any
        if (res.code === 200) {
          setIsValid(true)
        } else {
          setIsValid(false)
        }
      } catch (e) {
        setIsValid(false)
      } finally {
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [])

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    )
  }

  if (!isValid) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
